import $ from 'jquery'
import Backbone from 'backbone'
import _ from 'lodash'
import template from './ftp-connection-step1.hbs'
import formHelper from 'scoreboard/components/form-helper'
import selects from 'scoreboard/components/selects'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import constants from 'scoreboard/components/constants'
import { VALIDATE_URL } from 'scoreboard/admin/model/import-connection-constants'

let requiredFields = [ 'host', 'username', 'password' ]

var FtpConnectionStep1 = Backbone.View.extend({

	tagName: 'form',

	/**
	 * The first step of the wizard used to modify FTP connections (#13959)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Connection} options.model the connection being modified
	 *
	 * @param {String} options.title the title to use for the dialog
	 */
	initialize(options = {}) {
		this.options = options
	},

	events: {
		'change [name=authentication]': 'onChangeAuthentication'
	},

	render() {
		this.$el.empty().append(template({ title: this.options.title }))
		// before formHelper.writeToDom
		this.renderFtpSftpToggle()

		formHelper.writeToDom(this.model, this.el)
		// use presence of username to determine if this is anonymous or not
		if (!this.model.isNew() && this.model.get('username')) {
			this.$('[name=password]').val(constants.PASSWORD_PLACEHOLDER_KEY)
		}

		this.initAuthentication()
		selects(this.$('select'))

		this.renderMarkedFields()
		this.renderFormView()

		this.formView.start()

		return this
	},

	renderMarkedFields() {
		this.markedFields = _.map(requiredFields, field => {
			return new MarkedField({
				el: this.$(`[name=${field}]`),
				validator: requiredValidator
			}).render()
		})
	},

	renderFtpSftpToggle() {
		this.labeledToggle = new LabeledToggle({
			name: 'protocol',
			options: [{
				value: 'ftp',
				label: 'admin.importConnections.acronym.ftp'
			}, {
				value: 'sftp',
				label: 'admin.importConnections.acronym.sftp'
			}]
		})
		this.$('.toggle-container').append(this.labeledToggle.el)
		this.labeledToggle.render()
		this.labeledToggle.on('change', () => _.invoke(this.formView, 'change'))
	},

	renderFormView() {
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
	},

	/**
	 * Sets the appropriate value for the authentication dropdown
	 */
	initAuthentication() {
		let authentication = this.model.get('authentication')
		// we currently aren't actually storing the value for authentication
		// in the database, so just look for a username to figure out what
		// authentication type is in use
		if (!authentication) {
			authentication = this.model.get('username') ? 'username-password' : 'anonymous'
		}
		this.$('[name=authentication]').val(authentication)
		this.onChangeAuthentication()
	},

	onChangeAuthentication() {
		// show the appropriate fields based on the authentication type
		let authentication = this.$('[name=authentication]').val()
		this.$('[data-authentication-fields]').addClass('is-not-displayed')
		this.$(`.${authentication}`).removeClass('is-not-displayed')

		_.invokeMap(this.markedFields, 'redraw')
	},

	saveState() {
		_.extend(this.model.attributes, formHelper.readFromDom(this.el))
		if (this.$('[name=authentication]').val() === 'anonymous') {
			this.model.set('protocol', 'ftp')
		}
	},

	submit() {
		this.saveState()
		$.post({
			url: VALIDATE_URL,
			data: JSON.stringify(this.model.attributes),
			success: () => this.options.wizard.next(),
			error: this.formView.error.bind(this.formView)
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.labeledToggle,
			...this.markedFields], 'remove')
	}

})

export default FtpConnectionStep1

FtpConnectionStep1.__filename__ = 'admin/connections/ftp-connection-step1.js'
